import * as types from "../actions/actionTypes";

// isLogin : is the user trying to login
// logged : is the user logged
const initialState = {
  isLogin: false,
  logged: false
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_LOGIN:
      return { ...state, isLogin: true };
    case types.REQUEST_LOGOUT:
      return { ...state, logged: false };
    case types.LOGIN_SUCCESS:
      return { ...state, isLogin: false, logged: true };
    case types.LOGIN_FAIL:
      return { ...state, isLogin: false, logged: false };
    case types.LOGOUT_SUCCESS:
      return { ...state, isLogin: false, logged: false };
    case types.APP_FLUSH_DATAS:
      return {...state, isLogin: false, logged: false};
    default:
      return state;
  }
};

export default loginReducer;



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js